import React from 'react'
import CustomAlert from '../../shared/CustomAlert'
import UserProfileService from './../../../shared/services/UserProfile.service'
import LoadingSpinner from './../../shared/LoadingSpinner.component'
import {
  MDBBtn,
  MDBIcon,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
} from 'mdb-react-ui-kit'
import UserService from './../../../shared/services/User.service'
import ContentHtml from '../../content/ContentHtml/ContentHtml.component'
import UplineContactInfo from './UplineContactInfo.component'

import './UplineContactsModal.component.scss'

class UplineContactsModal extends React.Component {
  state = {
    isLoading: true,
    isOpen: false,
    isEmpty: false,
    uplines: [],
  }

  #toggleContactInfoModal = () => {
    if (!this.state.loading) {
      if (!this.state.isOpen) this.#fetchUplineContactsInfo()
      this.setState({ isOpen: !this.state.isOpen })
    }
  }

  #fetchUplineContactsInfo = async () => {
    // API now returns the upline nearest-first; no client-side reordering needed.
    const uplines = ((await UserService.getUpline(UserProfileService.getUserId())) || []).filter(
      Upline => parseInt(Upline.u_upline_id) > 0
    )

    this.setState(prevState => ({
      ...prevState,
      isLoading: false,
      uplines: uplines,
      isEmpty: uplines?.length === 0,
    }))
  }

  render() {
    return (
      <div id='UplineContactsModal'>
        <MDBBtn type='button' className='btn-block mb-1' color='indigo' onClick={this.#toggleContactInfoModal}>
          <MDBIcon icon='user-circle' className='me-1' /> Upline Contact Info
        </MDBBtn>

        <MDBModal open={this.state.isOpen} tabIndex='-1' onClose={this.#toggleContactInfoModal}>
          <MDBModalDialog size='lg'>
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>Upline Contact Info</MDBModalTitle>
                <MDBBtn
                  type='button'
                  className='btn-close'
                  color='none'
                  onClick={this.#toggleContactInfoModal}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody className={this.state.isLoading ? 'is-loading' : ''}>
                {this.state.isLoading ? (
                  <div className='loading-wrapper'>
                    <LoadingSpinner size='md' isActive={true} />
                  </div>
                ) : (
                  <>
                    <div>
                      <ContentHtml contentSlug='upline-contact-info-header' />
                    </div>
                    <div>
                      {this.state.isEmpty ? (
                        <CustomAlert color='warning'>You do not have any upline agents!</CustomAlert>
                      ) : (
                        this.state.uplines.map((upline, index) => {
                          return (
                            <div key={index}>
                              <UplineContactInfo
                                isDirectUpline={UserProfileService.get('u_upline_id') === upline.id}
                                upline={upline}
                              ></UplineContactInfo>
                              {index < this.state.uplines.length - 1 && (
                                <div className='text-center'>
                                  <MDBIcon far icon='arrow-alt-circle-down' size='3x' />
                                </div>
                              )}
                            </div>
                          )
                        })
                      )}
                    </div>
                    <MDBBtn type='button' color='warning' size={'sm'} block onClick={this.#toggleContactInfoModal}>
                      Close
                    </MDBBtn>
                  </>
                )}
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </div>
    )
  }
}

export default UplineContactsModal
